// Giá Gói Tổ chuyên môn: 999K/năm cho ≤5 GV; +150K/năm cho mỗi GV từ thứ 6.
export const GROUP_PLAN = { base: 999_000, perExtra: 150_000, freeSeats: 5 }

export const priceFor = (members: number): number =>
  GROUP_PLAN.base + Math.max(0, (members || 0) - GROUP_PLAN.freeSeats) * GROUP_PLAN.perExtra

export const fmtVnd = (n: number): string => (n || 0).toLocaleString('vi-VN') + 'đ'
